import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import { useAuth } from '@sportybot-web/auth/useAuth';
import { RuleForm } from '@sportybot-web/features/rules/components/rule-form/rule-form';
import { putRuleMutationOptions } from '@sportybot-web/services/sporty-gateway/rules/mutations';
import { ruleKeys } from '@sportybot-web/services/sporty-gateway/rules/queries';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';
import { noop } from 'es-toolkit';
import { useState } from 'react';

export const Route = createFileRoute('/_authenticated/rules/new')({
  component: RouteComponent,
});

function RouteComponent() {
  const queryClient = useQueryClient();
  const { user } = useAuth();
  const [ruleId, setRuleId] = useState<string | undefined>(undefined);
  const { error, isPending, mutate: putRule } = useMutation(putRuleMutationOptions());

  return (
    <Stack mt="space700">
      <RuleForm
        loading={isPending}
        onSubmit={(values, form) => {
          putRule(
            { rule: { ...values, username: user.email } },
            {
              onSuccess: ({ putRule }) => {
                setRuleId(putRule?.ruleId);
                void queryClient.invalidateQueries({ queryKey: [ruleKeys.all] });
                form.resetDirty();
              },
            },
          );
        }}
        serverError={error ? { error, title: 'Rule Creation Failed' } : null}
      />
      <Modal centered onClose={noop} opened={!!ruleId} padding="space100" withCloseButton={false}>
        <Stack gap="space50" mb="space400">
          <Title variant="heading-1">Success</Title>
          <Text>Your rule has successfully been created.</Text>
        </Stack>

        <Group gap="space100" justify="center">
          <Button component={Link} replace={true} to="/rules" variant="default">
            Back to Rules
          </Button>
          <Button component={Link} replace={true} to={`/rules/${ruleId}`}>
            Continue Editing
          </Button>
        </Group>
      </Modal>
    </Stack>
  );
}
